import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
/* eslint-disable boundaries/element-types */
import { SEARCH_PARAM_EXPLORATION_ID } from 'features/drilldown'
// eslint-disable-next-line boundaries/entry-point
import { PRESENTATION_MODE_QUERY_PARAMETER } from 'features/drilldown/data/savedExplorationState/useSearchParameter'
import { Drilldown } from 'pages/drilldown/Drilldown'
import { z } from 'zod'

const drilldownSearchParams = z.object({
  [PRESENTATION_MODE_QUERY_PARAMETER]: z.string().optional(),
  [SEARCH_PARAM_EXPLORATION_ID]: z.string().optional(),
})

export const Route = createFileRoute('/explorer/$siteID')({
  component: Drilldown,
  validateSearch: zodValidator(drilldownSearchParams),
})
